module.exports = __webpack_public_path__ + "img/pubCloud.d2076866.png";